import config from '../config';

export default {
	buildUrl: (view, params, skipParams) => {
		let urlFragments = [];

		skipParams = skipParams || [];

		if (params.page && skipParams.indexOf('sida') == -1) {
			urlFragments.push('sida/'+params.page);
		}
		if (params.sysla && skipParams.indexOf('sysla') == -1) {
			urlFragments.push('sysla/'+params.sysla);
		}
		if (params.hreppur && skipParams.indexOf('hreppur') == -1) {
			urlFragments.push('hreppur/'+params.hreppur);
		}
		if (params.sveitarfelag && skipParams.indexOf('sveitarfelag') == -1) {
			urlFragments.push('sveitarfelag/'+params.sveitarfelag);
		}
		if (params.tegund && skipParams.indexOf('tegund') == -1) {
			urlFragments.push('tegund/'+params.tegund);
		}

		return '/leit/'+(view || 'ornefni')+'/'+(params.searchString || '')+'/'+urlFragments.join('/');
	},

	createUrlParams: (params) => {
		let urlParams = [];

		if (params.searchString) {
			urlParams.push('q='+params.searchString);
			//urlParams.push('q='+params.searchString.split('*').join(''));

			/*
			if (params.searchString.startsWith('*') && params.searchString.endsWith('*')) {
				urlParams.push('m=inniheldur');
			}
			else if (params.searchString.startsWith('*')) {
				urlParams.push('m=endar');
			}
			if (params.searchString.endsWith('*')) {
				urlParams.push('m=byrjar');
			}
			*/
		}
		if (params.page) {
			urlParams.push('offset='+((params.page-1)*config.pageSize) : '');
		}
		if (params.sysla) {
			urlParams.push('sysla='+params.sysla);
		}
		if (params.sveitarfelag) {
			urlParams.push('sveitarfelag='+params.sveitarfelag);
		}
		if (params.hreppur) {
			urlParams.push('hreppur='+params.hreppur);
		}
		if (params.tegund) {
			urlParams.push('tegund='+params.tegund);
		}

		return urlParams;
	}
}



// WEBPACK FOOTER //
// ./src/utils/helpers.js